import { Button, Box, CheckBoxGroup, DataTable, Layer, Main, Text } from 'grommet'
import React, { Component, useState } from 'react'
import { FileDataRowDetails, PageHeader } from './Common'
import withOpsApi from './withOpsApi'
import { MotionBox, MotionLayer } from './Motion'
import { AnimatePresence } from 'framer-motion'
import { BarLoader } from 'react-spinners'
import { brandColors, meshTheme } from '../libs/theme'
import { appendPathWithSlash } from '../libs/common'
import { CloudDownload, Down, Download } from 'grommet-icons'
import { useParams } from 'react-router-dom'

const _OpsResultsTable = (props) => {
  const {
    fromApi: {
      apiPath,
      apiLoading,
      resultCount,
      resultPageSize = 50,
      results = [],
      resultFields = [],
      preFetchPages = 1
    },

    apiActions = {},
    apiFilterMenu,
    headerItems,
    manyFilterActionButtonProps = [],
    heading,
    showColumns = [],
    showDetails = false,
    renderResultWith = { ResultComponent: undefined },
    pad = { horizontal: 'medium' },
    dataTableProps = {},
    exportFileFunc,
    exportExcelConfig,
    history
  } = props
  let { id } = useParams() // individual record id could be passed to auto load
  let exportExcel = exportExcelConfig
  let showInColumnProps = []
  if (showColumns.length > 0) {
    showColumns.forEach((fieldItem, index) => {
      const size = index === 0 ? { size: 'xsmall' } : {}
      if (typeof fieldItem === 'object') {
        showInColumnProps.push({ ...size, header: fieldItem.property, ...fieldItem })
      } else {
        showInColumnProps.push({ property: fieldItem, header: fieldItem, ...size })
      }
    })
  } else {
    showInColumnProps = resultFields.map((fieldItem, index) => {
      return { property: fieldItem, header: fieldItem, size: index === 0 ? 'xsmall' : undefined }
    })
  }

  const exportOptions = () => {
    const config = {
      columns: exportExcel.columns,

      fileName: exportExcel.fileName,
      workSheetName: exportExcel.workSheetName,
      data: results
    }
    exportFileFunc(config)
  }
  const rowClicked = ({ index, datum = {} }) => {
    setClickedRow(datum)
    datum.id !== undefined && history.replace(history.location.pathname + '/' + datum.id)
    apiActions.setSelectedResult && apiActions.setSelectedResult({ index, result: datum })
  }
  const closeRow = (data) => {
    if (!data && clickedRow) {
      history.replace(history.location.pathname.replace('/' + clickedRow.id, ''))
    }
    setClickedRow(data)
  }
  const [clickedRow, setClickedRow] = useState(id ? { id: id } : null)
  const { ResultComponent, ...componentProps } = renderResultWith
  return results ? (
    <Box flex>
      <PageHeader height={'70px'} heading={heading}>
        <Box flex={'grow'} />
        <Text size={'small'} margin="small" color={'dark-6'} weight={'bold'}>
          {results && results.length + '/' + resultCount}
        </Text>
        {headerItems && headerItems}
        {manyFilterActionButtonProps &&
          manyFilterActionButtonProps.map(({ RenderComponent, ...rest }, index) => (
            <RenderComponent key={index} {...rest} {...props.fromApi} />
          ))}
        {apiFilterMenu && apiFilterMenu}
        {exportExcel.showExport && (
          <Button
            //   disabled={False}
            primary
            label="Download"
            icon={<CloudDownload />}
            onClick={exportOptions}
          />
        )}
      </PageHeader>

      <Box height={'4px'}>
        <BarLoader
          loading={apiLoading}
          color={meshTheme.global.colors['dark-6']}
          height={'4px'}
          width={'100%'}
        />
      </Box>
      <Main flex="shrink" pad={pad}>
        <DataTable
          fill={false} // otherwise entries appear stretched if 1 or 2
          replace={true}
          resizeable
          onClickRow={(e) => rowClicked(e)}
          rowDetails={showDetails ? FileDataRowDetails : undefined}
          primaryKey="id"
          pin
          step={resultPageSize * preFetchPages}
          onMore={results.length && apiActions.loadOnMore}
          columns={showInColumnProps}
          data={results}
          {...dataTableProps}
        />
      </Main>
      <AnimatePresence inital={false}>
        {ResultComponent && clickedRow && (
          <MotionLayer
            full
            plain
            modal={true}
            onEsc={() => closeRow(null)}
            // onClickOutside={() => setClickedRow(null)}
          >
            <ResultComponent
              apiPath={appendPathWithSlash(apiPath) + clickedRow.id + '/'}
              {...componentProps}
              closeAction={() => closeRow(null)}
            />
          </MotionLayer>
        )}
      </AnimatePresence>
    </Box>
  ) : null
}

_OpsResultsTable.defaultProps = {
  exportExcelConfig: {
    showExport: false,
    columns: [],
    fileName: '',
    workSheetName: ''
  }
}

export const OpsResultsTable = withOpsApi(_OpsResultsTable)
